const products = [
  {
    name: 'Caseta Cuadrada Reforzada Para Santiario Húmedo Con Tinaco',
    alt: 'Caseta Cuadrada Reforzada Para Santiario Húmedo Con Tinaco',
    main: true,
    photos: [
      '../assets/productos/sanitario_humedo_caseta_cuadrada_de_1.40.jpg',
      '../assets/productos/sanitario_humedo_caseta_cuadrada_de_1.40_.jpg',
      '../assets/productos/sanitario_humedo_caseta_cuadrada_de_1.40__.jpg',
    ],
    models: [
      {
        title: 'CASETA CUADRADA DE 1.05 MTS',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Estructura de refuerzo: PTR de 1 x 1 pulgadas\n',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA:',
            text:
              'Componentes: Marco con puerta, dos paneles laterales con estructura de refuerzo en ptr, panel trasero, toldo y estructura para carga de tinaco en ptr.\n' +
              'Espacio interior de la cabina una vez armada: de 1.0 x 1.0 mts; altura libre de 2.12 mts; espacio libre \n' +
              'de entrada 78 cms ancho, alto 1.83 mts altura.\n' +
              'Ventilación superior perimetral: 16 cms de alto\n' +
              'Ventilación inferior perimetral: 35 cms de alto.\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 16 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
        ],
      },
      {
        title: 'CASETA CUADRADA DE 1.20 MTS',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Estructura de refuerzo: PTR de 1 x 1 pulgadas',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA:',
            text:
              'Componentes: Marco con puerta, dos paneles laterales con estructura de refuerzo en ptr, panel trasero, toldo y estructura para carga de tinaco en ptr.\n' +
              'Espacio interior de la cabina una vez armada: de 1.20 x 1.20 mts; altura libre de 2.12 mts; espacio libre de entrada 79 cms ancho, alto 1.98 mts altura.\n' +
              'Ventilación superior perimetral: 17 cms de alto\n' +
              'Ventilación inferior perimetral: 35 cms de alto.\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 16 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
        ],
      },
      {
        title: 'CASETA CUADRADA DE 1.40 MTS',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Estructura de refuerzo: PTR de 1 x 1 pulgadas',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA:',
            text:
              'Componentes: Marco con puerta, dos paneles laterales con estructura de refuerzo en ptr, panel trasero, toldo y estructura para carga de tinaco en ptr.\n' +
              'Espacio interior de la cabina una vez armada: de 1.35 x 1.35 mts; altura libre de 2.12 mts; espacio libre de entrada 79 cms ancho, alto 1.98 mts altura.\n' +
              'Ventilación superior perimetral: 14 cms de alto\n' +
              'Ventilación inferior perimetral: 35 cms de alto.\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 16 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
        ],
      },
    ],
  },
  {
    name: 'Sanitario Ecológico Seco Modelo Cuadrado',
    alt: 'Baño seco, taza seca, sanitario sin agua',
    main: true,
    photos: ['../assets/productos/san1.png'],
    models: [
      {
        title: 'MODELO CUADRADO COMPLETO',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, separador de orina y base antiderrapante\n' +
              'Depósitos contenedores de excretas (2)\n' +
              'Tapa ciega para tanque contendor\n' +
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios ',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio en separador de orina: 21x13 cm\n' +
              'Espacio para excretas:  21x 17 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.95 x 0.95 m\n' +
              'Capacidad de depósitos para excretas: 275 litros a la salida de manguera del separador de orina\n' +
              'Dimensiones de depósitos: 0.82 x 0.82 x 0.71m   Forma piramidal invertida\n' +
              'Dimensiones tapa para depósito: 0.95 x0.95 m \n' +
              'Capacidad de carga de la tapa antes de ruptura: 250 kg',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA',
            text:
              'Componentes: Marco con puerta, dos paneles laterales, panel trasero y toldo\n' +
              'Espacio interior de la cabina una vez armada: de 1.0 x 1.0 mts; altura libre de 1.98 mts; espacio libre de entrada 78 cms ancho, alto 1.81 mts altura.\n' +
              'Ventilación superior perimetral: 21 cms de alto\n' +
              'Ventilación inferior perimetral: 10 cms de alto.\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 20 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero',
          },
          {
            subtitle: 'ACCESORIOS',
            text: '2 manguera de 1” x 3.0 mts en poliducto negro; 1 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado',
          },
        ],
      },
      {
        title: 'MODELO CUADRADO BÁSICO ',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, separador de orina y base antiderrapante\n' +
              'Depósitos contenedores de excretas (2)\n' +
              'Tapa ciega para tanque contendor\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios ',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio en separador de orina: 21x13 cm\n' +
              'Espacio para excretas: 21x 17 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.95 x 0.95 m\n' +
              'Capacidad de depósitos para excretas: 275 litros a la salida de manguera del separador de orina\n' +
              'Dimensiones de depósitos: 0.82 x 0.82 x 0.71m   Forma piramidal invertida\n' +
              'Dimensiones tapa para depósito: 0.95 x0.95 m \n' +
              'Capacidad de carga de la tapa antes de ruptura: 250 kg',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero',
          },
          {
            subtitle: 'ACCESORIOS',
            text: '2 manguera de 1” x 3.0 mts en poliducto negro; 1 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado',
          },
        ],
      },
    ],
  },
  {
    name: 'Sanitario Ecológico Seco Modelo Redondo',
    alt: 'Sanitario ecológico seco, baño sin agua',
    main: true,
    photos: ['../assets/productos/san4.png'],
    models: [
      {
        title: 'MODELO RENDONDO COMPLETO',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, separador de orina y base antiderrapante\n' +
              'Depósitos contenedores de excretas (2)\n' +
              'Tapa ciega para tanque contendor\n' +
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio y polietileno \n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios ',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio en separador de orina: 18x13 cm\n' +
              'Espacio para excretas: 23x 18 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.99 m Ø\n' +
              'Capacidad de depósitos para excretas: 300 litros a la salida de manguera del separador de orina\n' +
              'Dimensiones de depósitos: 0.97m Ø x 0.87m Semi cónicos\n' +
              'Dimensiones tapa para depósito: 0.99 m Ø\n' +
              'Capacidad de carga de la tapa antes de ruptura: 250 kg',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA',
            text:
              'Componentes: Marco con puerta, panel trasero y toldo\n' +
              'Espacio interior de la cabina una vez armada: de 1.10 mts Ø; altura libre de 2.00 mts; espacio libre de entrada 0.62 mts ancho, alto 1.75 mts altura.\n' +
              'Ventilación superior perimetral: 21 cms de alto\n' +
              'Ventilación inferior perimetral: 20 cms de alto.\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 14 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero',
          },
          {
            subtitle: 'ACCESORIOS',
            text: '2 manguera de 1” x 3.0 mts en poliducto negro; 1 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado',
          },
        ],
      },
      {
        title: 'MODELO REDONDO BÁSICO',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, separador de orina y base antiderrapante\n' +
              'Depósitos contenedores de excretas (2)\n' +
              'Tapa ciega para tanque contendor\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio y polietileno \n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios ',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio en separador de orina: 18x13 cm\n' +
              'Espacio para excretas: 23x 18 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.99 m Ø\n' +
              'Capacidad de depósitos para excretas: 300 litros a la salida de manguera del separador de orina\n' +
              'Dimensiones de depósitos: 0.97m Ø x 0.87m Semi cónicos\n' +
              'Dimensiones tapa para depósito: 0.99 m Ø\n' +
              'Capacidad de carga de la tapa antes de ruptura: 250 kg',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero',
          },
          {
            subtitle: 'ACCESORIOS',
            text: '2 manguera de 1” x 3.0 mts en poliducto negro; 1 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado',
          },
        ],
      },
    ],
  },
  {
    name: 'Sanitario Húmedo Con Reactor',
    alt: 'Sanitario Húmedo Con Reactor',
    main: false,
    photos: [
      '../assets/productos/sanitario_humedo_con _reactor.jpg',
      '../assets/productos/sanitario_humedo_con_reactor.jpg',
    ],
    models: [
      {
        title: 'Modelo único',
        sections: [
          {
            subtitle: 'FICHA TÉCNICA',
            text:
              'Funciona con bacterias bioenzimáticas que inhiben el olor y degradan la materia fecal produciendo solo agua que recibe un tratamiento de desinfección previo a su infiltración en el terreno, por lo que no requiere de la extracción y traslado de la materia fecal\n' +
              'Cuenta con un aereador del agua  que la mantiene en constante movimiento para favorecer la actividad bacteriana y  entre otras cosas evitar el mal olor\n' +
              'No requiere de energía eléctrica para su operación, ni de proveedores externos o supervisión regular.\n' +
              'Al hacer uso del sanitario húmedo con reactor, el usuario deposita directamente al reactor orina y  materia fecal  que caen directamente al agua en movimiento sin necesidad de ningún medio de arrastre o conducción.\n',
          },
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, sin separador de orina y base antiderrapante\n' +
              'Tanque reactor con Micro Tratadora SBR\n' +
              'Celda fotovoltaica\n' +
              'Tablero de control\n' +
              'Mingitorio\n' +
              'Lavamanos \n' +
              'Cabina modular \n' +
              'Tanque elevado para agua\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio y polietileno \n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios \n',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio para excretas: 23x 31 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.99 m Ø\n' +
              'Capacidad de reactor 800 litros\n' +
              'Dimensiones del reactor 0.76 M en la base x 1.28 M de altura\n' +
              'Tanque elevado para agua de 1.14 mts de diámetro x 42 cms. de alto\n' +
              'Mingitorio de 35 cm de alto x 25 cm de ancho\n' +
              'Lavamanos de 10 cm de alto x 25 cm de ancho y 38 cm de largo\n' +
              'Bacterias bioenzimáticas \n' +
              'Reactor biológico SBR con celda fotovoltaica y tablero de control\n',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA',
            text:
              'Componentes: Marco con puerta, panel trasero y toldo\n' +
              'Fijación de caseta  por fijación de patas a loza con  la aplicación de tornillos o ahogado de  las patas en el concreto.\n' +
              'Espacio interior de la cabina una vez armada: de 1.10 mts Ø; altura libre de 2.00 mts; espacio libre de entrada 0.62 mts ancho, alto 1.75 mts altura.\n' +
              'Ventilación superior perimetral: 21 cms de alto\n' +
              'Tanque elevado para agua de 400 litros\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 18 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado\n',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero\n',
          },
          {
            subtitle: 'ACCESORIOS',
            text: 'Conjunto de magueras y abrazaderas para instalación de lavamanos y mimgitorio.',
          },
        ],
      },
    ],
  },
  {
    name: 'Sanitario Portatil',
    alt: 'Mingitorio',
    main: true,
    photos: ['../assets/productos/san3.png'],
    models: [
      {
        title: 'MODELO PORTATIL',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, piernera y base antiderrapante\n' +
              'Depósito contenedor de desechos\n' +
              'Mingitorio  \n' +
              'Cabina modular \n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Conjunto de ventilación en tubería de pvc',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 50 cm\n' +
              'Espacio para en asiento para excretas: 33x 26 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.97 x 0.57 m\n' +
              'Capacidad del depósito para desechos: 300 litros al nivel del asiento\n' +
              'Mingitorio de 25 cm x 45 cm de alto',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA',
            text:
              'Componentes: Marco con puerta, dos paneles laterales con ventanas y malla protectora, panel trasero y toldo\n' +
              'Espacio interior de la cabina una vez armada: de 97 cm x 1.04 mts; altura libre de 2.10 mts; espacio libre de entrada 73 cms ancho, alto 1.92 mts altura.\n' +
              'Ventilación superior lateral (2): 41 x 21 cms de alto\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 16 piezas de 1” x ¼” en acero inoxidable con tuerca, rondanas y 37 remaches tipo pop\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              'Tubo de tiro o chimenea\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 1.90 mts\n' +
              'Material: PVC sanitario ligero',
          },
        ],
      },
    ],
  },
  {
    name: 'Sanitario Ecológico Seco Para Uso Agrícola',
    alt: 'Sanitario seco, taza ecológica, pozo de absorción',
    main: true,
    photos: ['../assets/productos/san-2.png'],
    models: [
      {
        title: 'MODELO AGRÍCOLA',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Taza para retrete con tapa, separador de orina y base antiderrapante\n' +
              'Depósitos contenedores de excretas (2)\n' +
              'Tapa ciega para tanque contendor\n' +
              'Mingitorio\n' +
              'Lavamanos \n' +
              'Cabina modular \n' +
              'Tanque elevado para agua\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio y polietileno \n' +
              'Conjunto de ventilación en tubería de pvc\n' +
              'Accesorios ',
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS DEL SANITARIO.',
            text:
              'Altura de taza: 32 cm\n' +
              'Espacio en separador de orina: 18x13 cm\n' +
              'Espacio para excretas: 23x 18 cms\n' +
              'Capacidad de carga: 250 kg antes de ruptura\n' +
              'Dimensiones de base antiderrapante: 0.99 m Ø\n' +
              'Capacidad de depósitos para excretas: 300 litros a la salida de manguera del separador de orina\n' +
              'Dimensiones de depósitos: 0.97m Ø x 0.87m Semi cónicos\n' +
              'Dimensiones tapa para depósito: 0.99 m Ø\n' +
              'Capacidad de carga de la tapa antes de ruptura: 250 kg\n' +
              'Tanque elevado para agua de 1.14 mts de diámetro x 42 cms. de alto\n' +
              'Mingitorio de 35 cm de alto x 25 cm de ancho\n' +
              'Lavamanos de 10 cm de alto x 25 cm de ancho y 38 cm de largo',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA CABINA',
            text:
              'Componentes: Marco con puerta, panel trasero y toldo\n' +
              'Espacio interior de la cabina una vez armada: de 1.10 mts Ø; altura libre de 2.00 mts; espacio libre de entrada 0.62 mts ancho, alto 1.75 mts altura.\n' +
              'Ventilación superior perimetral: 21 cms de alto\n' +
              'Ventilación inferior perimetral: 20 cms de alto.\n' +
              'Tanque elevado para agua de 400 litros\n' +
              'Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n' +
              'Tornillos para armado 18 piezas de 1” x ¼” en acero inoxidable con tuerca y rondana\n' +
              'Pasadores en puerta: fierro galvanizado',
          },
          {
            subtitle: 'CONJUNTO PARA VENTILACIÓN',
            text:
              '2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n' +
              'Diámetro de tubería: 3”\n' +
              'Longitud de tiro: 3 mts\n' +
              'Material: PVC sanitario ligero',
          },
          {
            subtitle: 'ACCESORIOS',
            text: '4 manguera de 1” x 3.0 mts en poliducto negro; 3 abrazaderas sin fin; un desarmador; un cucharón de ½ kg, e instructivo de armado, tubería de pvc y llave de plástico.',
          },
        ],
      },
    ],
  },
  {
    name: 'Bote Separador de Basura',
    alt: 'Bote Separador de Basura',
    main: false,
    photos: ['../assets/productos/bote_para_basura.jpg'],
    models: [
      {
        title: 'Modelo único',
        sections: [
          {
            subtitle: 'FICHA TÉCNICA',
            text:
              'Botes contenedores para basura con separación interior para el manejo de dos tipos de materiales como pueden ser orgánicos e inorgánicos.\n' +
              'Fabricados con resina poliéster reforzada con fibra de vidrio  con un laminado de 3 mm.\n' +
              'Terminado liso en la parte externa y rugoso en el interior, susceptible de limpiezas con detergente y cepillos suaves. Soporta el cloro.\n' +
              'En pedidos por volumen es posible fabricar con los colores que necesite el cliente.\n' +
              'Se recomienda utilizar bolsas de polietileno para recibir la basura en el interior  y facilitar su retiro.\n',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS.:',
            text: `
            Dimensiones: Altura: 57 cm; base: 30 cms por lado; abertura superior: 35 cm por lado
Capacidad: 60 litros
Dos entradas de depósito en la parte superior
Mampara divisora en la parte interna para evitar la mezcla de los materiales
Tapas removibles
`,
          },
        ],
      },
    ],
  },
  // {
  //   name: "Sanitario Ecológico Seco",
  //   main: true,
  //   photos: [
  //       "../assets/productos/sanitario_ecologico_seco_modelo_agricola.jpg",
  //       "../assets/productos/sanitario_ecologico_seco_modelo_agricola_.jpg",
  //       "../assets/productos/sanitario_ecologico_seco_modelo_cuadrado_completo.jpg",
  //       "../assets/productos/sanitario_ecologico_seco_redondo_basico.jpg"
  //   ],
  //   models: [
  //     {
  //       title: "MODELO CUADRADO",
  //       sections: [
  //         {
  //           subtitle: "COMPONENTES:",
  //           text: "Taza para retrete con  tapa, separador de orina y  base antiderrapante\n" +
  //               "Depósitos contenedores de excretas (2)\n" +
  //               "Tapa ciega para tanque contendor\n" +
  //               "Cabina modular \n" +
  //               "Material de fabricación: plástico reforzado con fibra de vidrio\n" +
  //               "Conjunto de ventilación en tubería de pvc\n" +
  //               "Accesorios "
  //         },
  //         {
  //           subtitle: "ESPECIFICACIONES TECNICAS DEL SANITARIO.",
  //           text: "Altura de taza: 32 cm\n" +
  //               "Espacio en separador de orina: 21x13 cm\n" +
  //               "Espacio para excretas:  21x 17 cms\n" +
  //               "Capacidad de carga: 250 kg antes de ruptura\n" +
  //               "Dimensiones de base antiderrapante: 0.95 x 0.95 m\n" +
  //               "Capacidad de depósitos para excretas: 275 litros  a la salida de manguera del separador de orina\n" +
  //               "Dimensiones de depósitos: 0.82 x 0.82 x 0.71m   Forma piramidal invertida\n" +
  //               "Dimensiones tapa para depósito: 0.95 x0.95 m \n" +
  //               "Capacidad de carga de la tapa antes de ruptura: 250 kg"
  //         },
  //         {
  //           subtitle: "ESPECIFICACIONES TÉCNICAS DE LA CABINA\n",
  //           text: "Componentes:  Marco con puerta, dos paneles laterales, panel trasero y toldo\n" +
  //               "Espacio interior de la cabina una vez armada:  de 1.0 x 1.0 mts; altura libre de 1.98 mts;  espacio libre de entrada 78 cms ancho, alto 1.81 mts altura.\n" +
  //               "Ventilación superior perimetral: 21 cms de alto\n" +
  //               "Ventilación inferior perimetral: 10 cms de alto.\n" +
  //               "Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n" +
  //               "Tornillos para armado 20 piezas  de 1” x ¼” en acero inoxidable con tuerca y rondana\n" +
  //               "Pasadores en puerta: fierro galvanizado"
  //         },
  //         {
  //           subtitle: "CONJUNTO PARA VENTILACIÓN",
  //           text: "2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n" +
  //               "Diámetro de tubería: 3”\n" +
  //               "Longitud de tiro: 3 mts\n" +
  //               "Material: PVC  sanitario ligero"
  //         },
  //         {
  //           subtitle: "ACCESORIOS",
  //           text: "2 manguera de 1” x 3.0 mts  en poliducto negro; 2 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado"
  //         },
  //       ]
  //     },
  //     {
  //       title: "MODELO CIRCULAR",
  //       sections: [
  //         {
  //           subtitle: "COMPONENTES:",
  //           text: "Taza para retrete con  tapa, separador de orina y  base antiderrapante\n" +
  //               "Depósitos contenedores de excretas (2)\n" +
  //               "Tapa ciega para tanque contendor\n" +
  //               "Cabina modular \n" +
  //               "Material de fabricación: plástico reforzado con fibra de vidrio y polietileno \n" +
  //               "Conjunto de ventilación en tubería de pvc\n" +
  //               "Accesorios "
  //         },
  //         {
  //           subtitle: "ESPECIFICACIONES TECNICAS DEL SANITARIO.",
  //           text: "Altura de taza: 32 cm\n" +
  //               "Espacio en separador de orina: 18x13 cm\n" +
  //               "Espacio para excretas:  23x 18 cms\n" +
  //               "Capacidad de carga: 250 kg antes de ruptura\n" +
  //               "Dimensiones de base antiderrapante: 0.99 m Ø\n" +
  //               "Capacidad de depósitos para excretas: 300 litros  a la salida de manguera del separador de orina\n" +
  //               "Dimensiones de depósitos: 0.97m Ø x 0.87m   Semi cónicos\n" +
  //               "Dimensiones tapa para depósito: 0.99 m Ø\n" +
  //               "Capacidad de carga de la tapa antes de ruptura: 250 kg"
  //         },
  //         {
  //           subtitle: "ESPECIFICACIONES TÉCNICAS DE LA CABINA",
  //           text: "Componentes:  Marco con puerta, panel  trasero y toldo\n" +
  //               "Espacio interior de la cabina una vez armada:  de 11.0 mts Ø; altura libre de 2.00 mts;  espacio libre de entrada 0.62 mts ancho, alto 1.75 mts altura.\n" +
  //               "Ventilación superior perimetral: 21 cms de alto\n" +
  //               "Ventilación inferior perimetral: 20 cms de alto.\n" +
  //               "Bisagras de aluminio tipo libro de 3 x 3 pulgadas\n" +
  //               "Tornillos para armado 12 piezas  de 1” x ¼” en acero inoxidable con tuerca y rondana\n" +
  //               "Pasadores en puerta: fierro galvanizado"
  //         },
  //         {
  //           subtitle: "CONJUNTO PARA VENTILACIÓN",
  //           text: "2 coples; 2 codos de 90° con malla; T con malla y tubo de tiro.\n" +
  //               "Diámetro de tubería: 3”\n" +
  //               "Longitud de tiro: 3 mts\n" +
  //               "Material: PVC  sanitario ligero"
  //         },
  //         {
  //           subtitle: "ACCESORIOS",
  //           text: "2 manguera de 1” x 3.0 mts  en poliducto negro; 2 abrazaderas sin fin; un desarmador; un cucharón de ½ kg,  e instructivo de armado"
  //         },
  //       ]
  //     },
  //   ]
  // },
  {
    name: 'Tapa Para Tambo Basurero',
    alt: 'Tapa Para Tambo Basurero',
    main: false,
    hide: true,
    photos: ['../assets/productos/tapas_para_tambo_basurero.jpg'],
    models: [],
  },
  // {
  //   name: "Tanque de Fibra",
  //   main: false,
  //   photos: [
  //       "../assets/productos/tanque_de_fibra.jpg"
  //   ],
  //   models: []
  // },
  // {
  //   name: "Tanque de Polietileno",
  //   main: false,
  //   photos: [
  //       "../assets/productos/tanque_de_polietileno.jpg"
  //   ],
  //   models: []
  // },
  {
    name: 'Perrera',
    alt: 'Perrera',
    main: false,
    hide: true,
    photos: ['../assets/productos/perrera.jpg'],
    models: [],
  },
  {
    name: 'Trampa de Grasa',
    alt: 'Trampa de Grasa',
    main: true,
    photos: [
      '../assets/productos/trampa _chica.jpg',
      '../assets/productos/trampa chica.JPG',
      '../assets/productos/trampa_de_grasas_grande.jpg',
      '../assets/productos/trampa_de_grasas_grande_.jpg',
      '../assets/productos/trampa_de_grasas_grande__.jpg',
      '../assets/productos/trampa_mini.jpg',
    ],
    models: [
      {
        title: 'TRAMPA GRANDE',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Caja o cuerpo\n' +
              'Peines y retenedores\n' +
              'Tapa o cubierta superior\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Estructura de refuerzo: solera de acero de 1 x 3/16 pulgadas\n' +
              'Conexiones de entrada y salida: PVC hidráulico 2 ½ pulgadas',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA TRAMPA',
            text:
              'Espacio interior de la trampa: 74 cm de largo x 35 cm de ancho y 23.5 cm de alto, lleva 2 peines y 5 retenedores de flujo, salida y entrada en conexiones pvc \n' +
              'Tapa superior: 83.5 cm de largo x 45 cm de ancho \n' +
              'Tornillos para colocación de tapa 10 piezas de 1 x ⅜” en acero inoxidable',
          },
        ],
      },
      {
        title: 'TRAMPA MEDIANA',
        sections: [
          {
            subtitle: 'COMPONENTES:',
            text:
              'Caja o cuerpo\n' +
              'Peines y retenedores\n' +
              'Tapa o cubierta superior\n' +
              'Material de fabricación: plástico reforzado con fibra de vidrio\n' +
              'Conexiones de entrada y salida: PVC hidráulico 2 ½ pulgadas',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS DE LA TRAMPA',
            text:
              'Espacio interior de la trampa: 46 cm de largo x 35 cm de ancho y 25 cm de alto, lleva 2 peines y 1 retenedor de flujo, salida y entrada en conexiones pvc \n' +
              'Tapa superior: 51 cm de largo x 43 cm de ancho \n' +
              'Marco perimetral de 5.5 cm de ancho para recibir la tapa',
          },
        ],
      },
      {
        title: 'TRAMPA CHICA',
        sections: [],
      },
    ],
  },
  {
    name: 'Caja Para Moto',
    alt: 'Caja Para Moto',
    main: false,
    photos: ['../assets/productos/san6.png'],
    models: [
      {
        title: 'Modelo único',
        sections: [
          {
            subtitle: 'FICHA TÉCNICA',
            text:
              'Cajas para motocicletas repartidoras fabricadas con resina poliéster reforzada con fibra de vidrio,  de superficie lisa y brillante ne la parte exterior  apta para adherir su marca,  logotipo  o texto con datos de identificación.\n' +
              'En pedidos especiales es posible fabricarlas en los colores que necesite.\n' +
              'El interior es rugoso. \n' +
              'Las superficies exteriores e interiores son susceptibles de lavarse con detergentes nobles  y  cepillos de cerdas suaves. soporta cloro. si utiliza instrumentos abrasivos puede dañar  irremediablemente la superficie cosmética.\n' +
              'Se fabrican tres tamaños diferentes con capacidades de  64, 114 y 115  litros.\n',
          },
          {
            subtitle: 'ESPECIFICACIONES TÉCNICAS',
            text:
              'Material de fabricación: resina poliéster reforzada con fibra de vidrio en  laminado de 3 milimetros \n' +
              'Medio de sujeción:   2 soleras de 1” x 1/8, ahogadas  en el fondo de la caja  para atornillar con firmeza a la base de la motocicleta\n' +
              'Tapa superior abatible hacia atrás con bisagra tipo piano a lo largo de  la base de la tapa .\n' +
              'Jaladera externa para abrir/cerrar fabricada en aluminio\n' +
              'Cerradura tipo resbalón\n' +
              'Color de línea, blanco.  en pedidos de varias piezas se puede fabricar en el color que indique el cliente. el rojo es más caro.\n',
          },
        ],
      },
    ],
  },
  {
    name: 'Lavamanos Itinerante',
    alt: 'Lavamanos Itinerante',
    main: false,
    photos: ['../assets/productos/lavamanos.jpg'],
    models: [
      {
        title: 'Modelo único',
        sections: [
          {
            subtitle: 'FICHA TÉCNICA',
            text: `Estación de lavado de manos itinerante para uso en centros de trabajo, oficinas públicas, centros comerciales, estaciones de transporte público, etc.`,
          },
          {
            subtitle: 'ESPECIFICACIONES TECNICAS',
            text: `Tanques de almacenamiento  fabricados con resina poliéster reforzada con fibra de vidrio. terminado liso y terso en la parte exterior, susceptible de aseo con detergentes nobles, cloro y cepillos de cerda suave. no resiste limpieza con materiales abrasivos.
MEDIDAS DEL MÓDULO:
Ancho: 0.72 M
Largo:  0.86 M
Alto: 1.20
Base metálica fabricada con ángulo de acero al carbón  de  1” x 1/8”  con medidas:
Alto 0.43
Ancho: 0.72m
Largo: 0.86 m
Tanque de almacenmiento de agua limpia  con capacidad de 100 litros y orificio de llenado en ½”
Tanque de almacenamiento  de aguas grises con capacidad de 220 litros y válvula de  drenado de 1”
Tarja de acero inoxidable  de 38 x 38 cms  x 14 cms de profundidad, con canastilla  
Llave de media vuelta en pvc de ½” de ø
Despachador de jabón líquido rellenable 
Despachador de toallas desechable
Altura total incluyendo base metálica: 1.63m
Peso total vacío, 48 kilos incluyendo base metálica.
`,
          },
        ],
      },
    ],
  },
];

export default products;
